import { createAction } from 'typesafe-actions'
import { IResetPassword } from '../types'

export const resetPassword = createAction('RESET_PASSWORD', (reset: IResetPassword) => reset)<IResetPassword>()
